var React = require('react');

function WaterInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#000","strokeLinejoin":"round","strokeWidth":"2","transform":"translate(4 1)"},[React.createElement("path",{"strokeLinecap":"square","d":"M8,22 C12.418278,22 16,18.418278 16,14 C16,8 11,3 8,0 C5,3 0,8.05925861 0,14 C0,18.418278 3.581722,22 8,22 Z","key":0}),React.createElement("path",{"d":"M8,17.99646 C11.0265262,17.99646 12,16.0003797 12,14.0042995","key":1})]));
}

WaterInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = WaterInline;

WaterInline.default = WaterInline;
